import { lazy, Suspense } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Footer from '../components/Footer';

const Stats = lazy(() => import('../components/Stats'));
const About = lazy(() => import('../components/About'));
const SupportBlock = lazy(() => import('../components/SupportBlock'));
const Products = lazy(() => import('../components/Products'));
const FreeSupport = lazy(() => import('../components/FreeSupport'));
const Testimonials = lazy(() => import('../components/Testimonials'));
const FAQ = lazy(() => import('../components/FAQ'));
const CTABanner = lazy(() => import('../components/CTABanner'));
const Disclaimer = lazy(() => import('../components/Disclaimer'));

function BelowFoldFallback() {
  return <div className="dh-below-fold-fallback" aria-hidden />;
}

export default function HomePage() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Suspense fallback={<BelowFoldFallback />}>
          <Stats />
          <About />
          <SupportBlock />
          <Products />
          <FreeSupport />
          <Testimonials />
          <FAQ />
          <CTABanner />
          <Disclaimer />
        </Suspense>
      </main>
      <Footer />
    </>
  );
}
